import React, { useContext, useEffect, useState } from "react";
import accounting from "accounting";
import styled from "styled-components";
import { ProductOptionStepsContext } from "../../../../Providers/ProductOptionStepsProvider";
import { TranslationContext } from "../../../../Providers/TranslationProvider";
import {
    FileUploadContext,
    PRICES
} from "../../../../Providers/FileUploadProvider/FileUploadProvider";
import { ApiService } from "../../../../../Shared/Services/ApiService";
import { VerspreidenContext } from "../../../../Providers/VerspreidenProvider";
import StepContainer from "../../../../UX/StepContainer/StepContainer";

const Overview = ({ step }) => {
    const {
        selectedOption,
        steps,
        productName,
        onAddProductToCart,
        sku
    } = useContext(ProductOptionStepsContext);
    const [template, setTemplate] = useState("");
    const { onShowUploadModal, files, extraOption } = useContext(
        FileUploadContext
    );
    const { verspreidDatums } = useContext(VerspreidenContext);

    const { trans } = useContext(TranslationContext);

    const werktekening = async () => {
        if (selectedOption) {
            try {
                const res = await ApiService.get(
                    "/werktekeningforsku/" + sku
                ).then(result => setTemplate(result));
            } catch (e) {
            }
        }
    };

    useEffect(() => {
        werktekening();
    }, [selectedOption]);

    if (!selectedOption) {
        return null;
    }

    const stepA = {
        description: <>Voeg bestanden toe en rond bestelling af</>,
        step_description: (
            <>
                Hiernaast hebben we alles nog een keer op een rijtje gezet.
                Controleer of je alles juist hebt geselecteerd. Heb je al een
                bestand? Dan kun je die alvast uploaden, dan gaan wij er direct
                mee aan de slag als je de bestelling plaatst.
            </>
        ),
        id: step.id
    };

    return (
        <>
            <StepContainer step={stepA}>
                <div className="flex flex-wrap -mx-2">
                    <div className="px-2 w-full lg:w-1/2">
                        <h2 className="text-xl mb-2 font-bold">
                            Controleer je keuzes
                        </h2>
                        <div className="w-full bg-white p-4 rounded border border-gray-200 mb-3">
                            <div>
                                <span className="text-gray-600">
                                    {trans("product", true)}
                                </span>
                            </div>
                            <div className="mb-2">
                                <p>
                                    <b>{productName}</b>
                                </p>
                            </div>

                            {steps.map(step => (
                                <ProductAttribute
                                    key={step.id}
                                    qty={selectedOption.qty}
                                    step={step}
                                />
                            ))}
                            {verspreidDatums && (
                                <>
                                    <div>
                                        <span className="text-gray-600">
                                            Verspreidingsdatum
                                        </span>
                                    </div>
                                    <div className="mb-2">
                                        <p>
                                            <b>{verspreidDatums}</b>
                                        </p>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="px-2 w-full lg:w-1/2">
                        <h2 className="text-xl mb-2 font-bold">Prijs</h2>
                        <div className="w-full bg-white p-4 rounded border border-gray-200 mb-3">
                            <div className="w-full text-gray-600">
                                {trans("price_without_VAT", true)}
                            </div>
                            <div className="w-full mb-2">
                                {selectedOption.price_discount ? (
                                    <b>
                                        {accounting.formatMoney(
                                            selectedOption.price_discount,
                                            "€",
                                            2,
                                            ".",
                                            ","
                                        )}
                                    </b>
                                ) : (
                                    <b>
                                        {accounting.formatMoney(
                                            selectedOption.price_ex,
                                            "€",
                                            2,
                                            ".",
                                            ","
                                        )}
                                    </b>
                                )}
                            </div>
                            {extraOption && (
                                <>
                                    <div className="w-full text-gray-600">
                                        Extra bestandsoptie:
                                    </div>
                                    <div className="w-full mb-2">
                                        <b>
                                            {" "}
                                            {accounting.formatMoney(
                                                PRICES[extraOption],
                                                "€",
                                                2,
                                                ".",
                                                ","
                                            )}
                                        </b>
                                    </div>
                                </>
                            )}
                            <div className="text-gray-600">
                                {trans("total", true)}
                            </div>
                            <div className="mb-2">
                                {extraOption ? (
                                    <b>
                                        {" "}
                                        {accounting.formatMoney(
                                            selectedOption.price_in +
                                                PRICES[extraOption] * 1.21,
                                            "€",
                                            2,
                                            ".",
                                            ","
                                        )}
                                    </b>
                                ) : (
                                    <b>
                                        {" "}
                                        {accounting.formatMoney(
                                            selectedOption.price_in,
                                            "€",
                                            2,
                                            ".",
                                            ","
                                        )}
                                    </b>
                                )}
                            </div>
                        </div>
                        {template.data && template.data.werktekening.folder && (
                            <>
                                <h2 className="text-xl mb-2 font-bold">
                                    Werktekening & Template
                                </h2>
                                <div className="w-full bg-white p-4 rounded border border-gray-200 mb-3">
                                    <div className="flex flex-wrap -mx-2">
                                        <div className="w-full px-2 mb-4">
                                            {template.data.werktekening.info}
                                        </div>
                                        {Object.entries(
                                            template.data.werktekening.templates
                                        ).map((file, key) => (
                                            <div
                                                key={key}
                                                className="w-1/2 px-2 mb-3"
                                            >
                                                <div className="flex">
                                                    <div className="w-8/12">
                                                        <a
                                                            href={
                                                                "storage/werktekeningen/" +
                                                                template.data
                                                                    .werktekening
                                                                    .folder +
                                                                "/" +
                                                                file[1]
                                                            }
                                                        >
                                                            <b>
                                                                {file[0]
                                                                    .charAt(0)
                                                                    .toUpperCase() +
                                                                    file[0].slice(
                                                                        1
                                                                    )}
                                                            </b>
                                                        </a>
                                                    </div>
                                                    <div className="w-4/12">
                                                        <a
                                                            href={
                                                                "storage/werktekeningen/" +
                                                                template.data
                                                                    .werktekening
                                                                    .folder +
                                                                "/" +
                                                                file[1]
                                                            }
                                                        >
                                                            <img
                                                                src={
                                                                    "images/general/" +
                                                                    file[0] +
                                                                    "-icon.png"
                                                                } alt="icon"
                                                            />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
                <div className="flex justify-between">
                    <button
                        onClick={onShowUploadModal}
                        className="bg-blue-500 text-white px-4 py-2 text-white rounded mr-2 font-bold hover:bg-blue-600"
                    >
                        {files.length > 0 ? (
                            <>{files.length} bestanden toegevoegd</>
                        ) : (
                            <>
                                <i className="fas fa-file-upload mr-1" /> Voeg
                                bestanden toe
                            </>
                        )}
                    </button>
                    <button
                        onClick={() =>
                            onAddProductToCart(
                                selectedOption.delivery,
                                selectedOption.variation_id,
                                selectedOption.qty,
                                selectedOption.product_id,
                                selectedOption.price_in
                            )
                        }
                        className="bg-yellow-200 text-yellow-900 px-4 py-2 text-white rounded mr-2 font-bold hover:bg-yellow-400 uppercase"
                    >
                        <>
                            <i className="fas fa-plus mr-1" />
                            In winkelwagen
                        </>
                    </button>
                </div>
            </StepContainer>
        </>
    );
};

export default Overview;

const ProductAttribute = ({ step, qty }) => {
    const chosenOption = step.options.find(option => option.selected) || false;
    if (step.id === "file_upload" || step.id === "overview") {
        return null;
    }

    if (step.id === "qty") {
        return (
            <>
                <div>
                    <span className="text-gray-600">{step.description}:</span>
                </div>
                <div className="mb-2">
                    <p>
                        <b>{qty}</b>
                    </p>
                </div>
            </>
        );
    }

    if (
        chosenOption.value === "cfcm" ||
        chosenOption.value === "hoogtebreedte" ||
        chosenOption.value === "cfmm"
    ) {
        return (
            <>
                <div>
                    <span className="text-gray-600">{step.description}:</span>
                </div>
                <div className="mb-2">
                    <p>
                        <b>
                            {chosenOption.fields
                                .map(field => field.value)
                                .join(" x ")}{" "}
                            (hoogte x breedte)
                        </b>
                    </p>
                </div>
            </>
        );
    }

    if (chosenOption.value === "gebied") {
        return (
            <>
                <div>
                    <span className="text-gray-600">{step.description}:</span>
                </div>
                <div className="mb-2">
                    <p>
                        <b>
                            {chosenOption.fields[0].value.replace(/x/g, ", ")}
                        </b>
                    </p>
                </div>
            </>
        );
    }

    if (chosenOption.value === "pages_inside") {
        return (
            <>
                <div>
                    <span className="text-gray-600">{step.description}:</span>
                </div>
                <div className="mb-2">
                    <p>
                        <b>
                            {chosenOption.fields[0].value} (zwart/wit){" "}
                            {chosenOption.fields[1].value} (kleur)
                        </b>
                    </p>
                </div>
            </>
        );
    }

    return (
        <>
            <div>
                <span className="text-gray-600">{step.description}:</span>
            </div>
            <div className="mb-2">
                <p>
                    <b>{chosenOption.name}</b>
                </p>
            </div>
        </>
    );
};

// const FavCon = styled.div`
//     display: flex;
//     justify-content: center;
//     padding: 0px 10px;
//     align-items: center;
//     flex-direction: column;
//     span {
//         font-size: 0.8rem;
//         text-align: center;
//         margin-bottom: 12px;
//     }
// `;

// const FavButton = ({ auth, state, onSetSkuAsFavorite, duplicate }) => {
//     const { trans } = useContext(TranslationContext);

//     if (!auth) {
//         return null;
//     }
//     if (state.error) {
//         return (
//             <>
//                 <div className="callout alert">
//                     <h5>{trans("something_went_wrong", true)}</h5>
//                     <p>{trans("fav_not_added", true)}</p>
//                 </div>
//             </>
//         );
//     }
//     if (duplicate) {
//         return (
//             <>
//                 <div className="grid-x">
//                     <div className="cell large-12">
//                         <hr className="plain" />
//                     </div>
//                 </div>
//                 <FavCon>
//                     <span style={{ width: "100%" }}>
//                         {trans("save_fav_product_description", true)}
//                     </span>
//                     <button
//                         onClick={onSetSkuAsFavorite}
//                         className="button hollow"
//                         disabled
//                     >
//                         <i className="fas fa-heart" />{" "}
//                         <span style={{ width: "100%" }}>
//                             {trans("product_combi_already_favorite", true)}
//                         </span>
//                     </button>
//                 </FavCon>
//             </>
//         );
//     }
//     if (state.loading) {
//         return (
//             <>
//                 <div className="grid-x">
//                     <div className="cell large-12">
//                         <hr className="plain" />
//                     </div>
//                 </div>
//                 <FavCon>
//                     <span style={{ width: "100%" }}>
//                         {trans("save_fav_product_description", true)}
//                     </span>
//                     <button
//                         onClick={onSetSkuAsFavorite}
//                         className="button hollow"
//                     >
//                         <i className="fas fa-heart" /> {trans("saving", true)}
//                     </button>
//                 </FavCon>
//             </>
//         );
//     }
//     if (state.success) {
//         return (
//             <>
//                 <div className="grid-x">
//                     <div className="cell large-12">
//                         <hr className="plain" />
//                     </div>
//                 </div>
//                 <FavCon>
//                     <span style={{ width: "100%" }}>
//                         {trans("save_fav_product_description", true)}
//                     </span>
//                     <button
//                         onClick={onSetSkuAsFavorite}
//                         className="button success"
//                     >
//                         <i className="fas fa-heart" /> {trans("saved", true)}
//                     </button>
//                 </FavCon>
//             </>
//         );
//     }
//     return (
//         <>
//             <div className="grid-x">
//                 <div className="cell large-12">
//                     <hr className="plain" />
//                 </div>
//             </div>
//             <FavCon>
//                 <span style={{ width: "100%" }}>
//                     {trans("save_fav_product_description", true)}
//                 </span>
//                 <button onClick={onSetSkuAsFavorite} className="button hollow">
//                     <i className="fas fa-heart" />{" "}
//                     {trans("save_to_favorites", true)}
//                 </button>
//             </FavCon>
//         </>
//     );
// };
